import { ComplexAction, createHandler, createReducer } from "../../../core/actions";

export const initState = {
    unreportedCount: 0,
};

export class SET_UNREPORTED_COUNT extends ComplexAction {}

export const actions = {
    SET_UNREPORTED_COUNT: new SET_UNREPORTED_COUNT(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);

export const unreportedCountSelector = (state) => state.advertising2.unreportedCount;
